import moment, { Moment } from 'moment';
import User from '@/shared/models/User';
import Job from './Job';

export interface TimeRegistrationId {__timeEntryId: number;}

export default class TimeRegistration {
  id!: TimeRegistrationId;
  sequenceNumber = 0;
  startedBy = new User();
  startedOn = moment();
  stoppedBy: User | null = null;
  stoppedOn: Moment | null = null;
  jobs: Array<Job> = [];
}